// Attention and Activity: Quick Questionnaire (ADHD-Screener). The wording comes from the form list
// (api/shared_code/adhd_screener.py); this only picks the right version for who is answering.
// "self" reads "you"; a parent or carer, or anyone else, reads "them", with {person} filled in.

export function wordingFor(who) {
  return who === "self" ? "you" : "them";
}

export function fill(text, who) {
  const parent = who === "parent";
  return String(text || "")
    .replace(/\{person\}/g, parent ? "your child" : "the person you're answering about")
    .replace(/\{Person\}/g, parent ? "Your child" : "Their");
}

export function questionText(q, who) {
  return wordingFor(who) === "you" ? q.you : fill(q.them, who);
}

export function partTitle(part, who) {
  return wordingFor(who) === "you" ? part.you : fill(part.them, who).replace("the person you're answering about", "them");
}

export function stemFor(stems, who) {
  return stems[who === "self" ? "self" : who === "parent" ? "parent" : "other"];
}

// Age in whole years (and months under 18) on a given day. dob is YYYY-MM-DD.
export function ageText(dob, today = new Date()) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dob || ""));
  if (!m) return "";
  const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
  let months = (today.getFullYear() - y) * 12 + (today.getMonth() + 1 - mo) - (today.getDate() < d ? 1 : 0);
  if (months < 0) return "";
  const years = Math.floor(months / 12);
  const rest = months % 12;
  const ys = `${years} year${years === 1 ? "" : "s"}`;
  return years >= 18 ? ys : `${ys} ${rest} month${rest === 1 ? "" : "s"}`;
}

// Adult: answering about yourself, or "Other" about someone 18 or older (from their date of birth).
export function isAdult(who, dob, today = new Date()) {
  if (who === "self") return true;
  if (who !== "other") return false;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dob || ""));
  if (!m) return false;
  const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
  let age = today.getFullYear() - y;
  if (today.getMonth() + 1 < mo || (today.getMonth() + 1 === mo && today.getDate() < d)) age -= 1;
  return age >= 18;
}

// The answer options a person sees: child-only or adult-only options filtered, "you" wording for self.
export function optionsFor(screener, qid, who, adult) {
  const rules = (screener.option_rules || {})[qid] || {};
  return (screener.options[qid] || [])
    .filter((o) => {
      const f = (rules[o.value] || {}).for;
      return !(f === "child" && adult) && !(f === "adult" && !adult);
    })
    .map((o) => {
      const rule = rules[o.value] || {};
      if (who === "self" && rule.you) return { value: o.value, label: rule.you };
      if (adult && rule.adult) return { value: o.value, label: rule.adult };
      return { value: o.value, label: o.label };
    });
}
